import { Providers } from "@microsoft/mgt";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CookieProxyProvider } from "../../../app/CustomGraphProxy";
import { userData } from "../../Common/Store/CommonSignals";
import { groupIdsToNames } from "../../Utilities/AuthorizationUtil";
import { graphUserByEmailUrl } from "../../Utilities/GraphUserLookup";

const AuthCallback = ({ handleAuthentication }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const processCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const sessionToken = urlParams.get("sessionToken");
      const returnUrl = urlParams.get("returnUrl") || "/";

      if (!sessionToken) {
        setError("Session Token not found");
        setLoading(false);
        return;
      }

      localStorage.setItem("atlas.sessionToken", sessionToken);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/auth/saml/session-info?sessionToken=${sessionToken}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${sessionToken}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Authentication failed!");
        }

        const userDataJson = await response.json();
        const email = userDataJson.username;
        userData.value = {
          ...userData.value,
          userEmail: email,
          officeLocation: "",
          groups: [],
        };

        const [groupsResult, profileResult] = await Promise.allSettled([
          axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/GraphProxy/v1.0/me/groups`),
          axios.get(graphUserByEmailUrl(email)),
        ]);

        if (groupsResult.status === "fulfilled") {
          const graphNames = groupsResult.value.data?.groups ?? [];
          const graphIds = groupsResult.value.data?.groupIds ?? [];
          const resolvedNames = graphNames.length > 0 ? graphNames : groupIdsToNames(graphIds);
          userData.value = { ...userData.value, groups: resolvedNames };
        } else {
          console.error("[AuthCallback] Failed to fetch groups from Graph:", groupsResult.reason);
        }

        if (profileResult.status === "fulfilled") {
          const user = profileResult.value.data?.value?.[0];
          if (user) {
            userData.value = {
              ...userData.value,
              officeLocation: user.officeLocation ?? "",
              displayName: user.displayName ?? "",
            };
          }
        } else {
          console.error("[AuthCallback] Failed to fetch profile from Graph:", profileResult.reason);
        }

        handleAuthentication(true);

        let provider = new CookieProxyProvider(
          `${process.env.REACT_APP_API_ENDPOINT}/api/GraphProxy/v1.0`,
          async () => ({
            Authorization: `Bearer ${localStorage.getItem("atlas.sessionToken")}`,
            "X-User-Email": userData.value?.userEmail,
          })
        );
        Providers.globalProvider = provider;
        provider.initialize();

        const parsedUrl = new URL(returnUrl, window.location.origin);
        navigate(parsedUrl.pathname + parsedUrl.search);
      } catch (err) {
        handleAuthentication(false);
        setError(err.message);
        setLoading(false);
      }
    };

    processCallback();
  }, [navigate]);

  if (loading) {
    return <div>Processing authentication...</div>;
  }

  if (error) {
    return <div>Authentication error: {error}</div>;
  }

  return null;
};

export default AuthCallback;
